<div class="flex w-full items-center border-t px-6 py-8">
  <button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
      @if (!showAvatar) {
      <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
      }
    </span>
  </button>
  <div class="ml-4 flex w-full flex-col overflow-hidden">
    <div
      class="w-full overflow-hidden text-ellipsis whitespace-nowrap leading-normal text-current opacity-80"
    >
      {{ username }}
    </div>
    <div
      class="mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm leading-normal text-current opacity-50"
    >
      {{ email }}
    </div>
  </div>
</div>

<!-- Button -->
<!-- <button mat-icon-button [matMenuTriggerFor]="userActions">
  <span class="relative">
    @if (!showAvatar || !user.avatar) {
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    }
  </span>
</button> -->

<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <!-- <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider> -->
  <button mat-menu-item disabled>
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    <span>{{ 'userMenu.profile' | transloco }}</span>
  </button>
  <button mat-menu-item disabled>
    <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
    <span>{{ 'userMenu.settings' | transloco }}</span>
  </button>
  <!-- <button mat-menu-item [matMenuTriggerFor]="userStatus">
        <mat-icon
            [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"
        ></mat-icon>
        <span>Status</span>
    </button> -->
  <mat-divider class="my-2"></mat-divider>
  @if (isLoggedIn) {
  <button mat-menu-item (click)="signOut()">
    <mat-icon
      [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
    ></mat-icon>
    <span>{{ 'userMenu.signOut' | transloco }}</span>
  </button>
  } @else {
  <button mat-menu-item (click)="signIn()">
    <mat-icon
      [svgIcon]="'heroicons_outline:arrow-left-on-rectangle'"
    ></mat-icon>
    <span>{{ 'userMenu.signIn' | transloco }}</span>
  </button>
  }
</mat-menu>

<!-- <mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu> -->
